import React, { useContext, useState } from 'react'

import pxToRem from '../../utils/pxToRem'
import { IconTypeEnum } from '../../theme/icons'

import IconButton from '../IconButton/IconButton'
import IconBurgerMenu from '../../images/icons/menu-fill.svg'
import IconCloseMenu from '../../images/icons/close-menu.svg'
import LayoutContext from '../../contexts/LayoutContext'
import { handleOverflow } from '../../utils/HandleOverflow'

const BurgerMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { setMenuIsOpen } = useContext(LayoutContext)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
    setMenuIsOpen(!isMenuOpen)

    handleOverflow(!isMenuOpen)
  }

  return (
    <>
      <IconButton
        ariaLabel={'menu'}
        onClick={toggleMenu}
        height={pxToRem(24)}
        width={pxToRem(24)}
        type={IconTypeEnum.burgerMenu}
        isMenuOpen={isMenuOpen}
      >
        {isMenuOpen ? <IconCloseMenu /> : <IconBurgerMenu />}
      </IconButton>
    </>
  )
}

BurgerMenu.propTypes = {}

export default BurgerMenu
